export type Primitive = string | number | boolean;

export function getNumber(x: unknown): number | null {
  if (typeof x === "number") {
    return isNaN(x) ? null : x;
  }

  return typeof x === "string" ? getNumber(parseFloat(x)) : null;
}

export function getString(x: unknown): string | null {
  return typeof x === "string" ? x : null;
}

export function getPrimitiveArray<T extends Primitive>(
  x: unknown,
  getType: (value: unknown) => T | null
): T[] {
  if (Array.isArray(x)) {
    const elts = x.map(getType);
    return elts.includes(null) ? [] : (elts as T[]);
  }
  return [];
}
